<template>
  <section class="fhir-section">
    <div class="fhir-inner">
      <!-- Left -->
      <div class="fhir-left">
        <div class="fhir-title-row">
          <svg
            class="fhir-title-icon"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M36.8688 13.5187L20.4438 6.57495C20.3174 6.52083 20.1813 6.49292 20.0438 6.49292C19.9063 6.49292 19.7702 6.52083 19.6438 6.57495L3.13753 13.4937C2.95172 13.5756 2.79365 13.7097 2.68247 13.8796C2.57129 14.0495 2.51177 14.248 2.51111 14.4511C2.51046 14.6541 2.56871 14.853 2.67879 15.0237C2.78888 15.1943 2.94608 15.3293 3.13136 15.4125C4.10699 15.8305 9.81746 18.2264 10.6187 18.5749L19.6438 22.3812C19.901 22.4839 20.1882 22.4816 20.4438 22.375C23.3433 21.1515 30.8275 17.9878 33.6125 16.8062C33.6057 17.5799 33.6174 24.1039 33.6125 25.05C32.3711 25.3631 31.8671 27.4793 32.5626 28.625L31.6438 32.75C31.6146 32.8737 31.6249 33.0035 31.6731 33.1211C31.7212 33.2388 31.805 33.3384 31.9125 33.4062C32.0193 33.4761 32.1452 33.5113 32.2727 33.5068C32.4003 33.5023 32.5234 33.4584 32.625 33.3812C33.0694 33.053 33.604 32.8697 34.1563 32.8562C34.7439 32.8475 35.3177 33.0344 35.7875 33.3875C35.8933 33.4618 36.0193 33.5019 36.1486 33.5024C36.2779 33.5028 36.4042 33.4636 36.5105 33.39C36.6168 33.3164 36.698 33.212 36.743 33.0908C36.7881 32.9696 36.7949 32.8376 36.7625 32.7124L35.5938 28.6062C36.1953 27.5751 35.8682 25.7232 34.8625 25.2063C34.8682 24.252 34.8585 17.0322 34.8625 16.2812L36.8688 15.4312C37.0535 15.3487 37.2103 15.2145 37.3204 15.0448C37.4305 14.8752 37.489 14.6772 37.489 14.475C37.489 14.2727 37.4305 14.0747 37.3204 13.9051C37.2103 13.7354 37.0535 13.6012 36.8688 13.5187Z"
              fill="black"
            />
            <path
              d="M19.1563 23.5313C18.4036 23.2137 9.83252 19.5911 9.36877 19.4V25.4875C9.37303 25.8144 9.45659 26.1353 9.61227 26.4227C9.76795 26.7101 9.99109 26.9554 10.2625 27.1375C13.0103 29.0056 16.235 30.0487 19.5563 30.1438C23.1956 30.2161 26.7701 29.1736 29.8 27.1562C30.0782 26.9732 30.3074 26.7249 30.4676 26.433C30.6277 26.141 30.714 25.8143 30.7188 25.4813V19.3938C30.2853 19.5819 21.6668 23.2203 20.9313 23.5313C20.3628 23.7656 19.7248 23.7656 19.1563 23.5313Z"
              fill="black"
            />
          </svg>
          <h2 class="fhir-h2">培訓認證</h2>
        </div>

        <div class="fhir-cards-container">
          <div class="fhir-card-wrap" v-for="(card, i) in cards" :key="i">
            <div class="fhir-card">
              <div class="fhir-card-content">
                <p class="fhir-card-title">{{ card.title }}</p>
                <p class="fhir-card-desc">{{ card.desc }}</p>
              </div>
              <div class="fhir-card-footer">
                <router-link :to="card.link" custom v-slot="{ navigate }">
                  <button class="fhir-card-btn" @click="navigate">
                    {{ card.btnText }}
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Image (Outside of container, fixed at bottom right) -->
    <div class="fhir-right">
      <img src="/trainee.webp" alt="Trainee" class="fhir-trainee-img" />
    </div>
  </section>
</template>

<script setup>
const cards = [
  {
    title: "工作坊課程",
    desc: "提供 LOINC 標準教育訓練、交流活動及相關資訊，協助了解檢驗資料標準化的基本概念、編碼原則及實務應用，相關內容將依推動規劃陸續公告。",
    btnText: "前往課程",
    link: "/workshop-courses",
  },
  {
    title: "工作坊官方教材",
    desc: "彙整 LOINC 官方文件、教材、技術指南及相關學習資源，提供醫療機構、資訊人員及相關從業人員作為檢驗資料標準化建置與應用之參考。",
    btnText: "前往教材",
    link: "/workshop-materials",
  },
  {
    title: "認證申請專區",
    desc: "提供認證制度、資格條件及相關說明，協助了解認證機制與辦理方式；如有最新消息將於本專區陸續公告。",
    btnText: "前往專區",
    link: "/certification-apply",
  },
];
</script>

<style scoped>
/* ════════════════════════════════════════
   Section shell
   ════════════════════════════════════════ */
.fhir-section {
  position: relative;
  font-family: "Noto Sans TC", sans-serif;
  background: #f9f9f9;
  background-image: linear-gradient(
    0deg,
    rgba(220, 243, 249, 0.3),
    rgba(220, 243, 249, 0.3)
  );
  padding: 72px 64px 80px;
  min-height: 848px;
}

/* ════════════════════════════════════════
   Inner layout: two columns
   ════════════════════════════════════════ */
.fhir-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  gap: 64px;
}

/* ════════════════════════════════════════
   LEFT column
   ════════════════════════════════════════ */
.fhir-left {
  flex: 1;
  min-width: 0;
}
@media (min-width: 992px) {
  .fhir-left {
    max-width: 65%;
  }
}

/* Title row */
.fhir-title-row {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 40px;
}
.fhir-title-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}
.fhir-h2 {
  font-size: 32px;
  font-weight: 700;
  color: #333333;
  margin: 0;
  line-height: 1.3;
}

/* Cards Container */
.fhir-cards-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.fhir-card-wrap {
  display: block;
}

/* Card */
.fhir-card {
  flex: 1;
  background: #ffffff;
  border-radius: 20px;
  padding: 24px 28px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 196px;
}
.fhir-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.fhir-card-title {
  font-size: 20px;
  font-weight: 700;
  color: #0098da;
  margin: 0;
  line-height: 1.4;
}
.fhir-card-desc {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  margin: 0;
  line-height: 1.7;
  white-space: pre-wrap;
}
.fhir-card-footer {
  display: flex;
  align-items: center;
}
.fhir-card-btn {
  background: #0098da;
  color: #ffffff;
  border: none;
  border-radius: 17px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s;
}
.fhir-card-btn:hover {
  background: #007bb5;
  transform: translateY(-1px);
}

/* ════════════════════════════════════════
   RIGHT column (Absolute bottom-right image)
   ════════════════════════════════════════ */
.fhir-right {
  position: absolute;
  right: 0;
  bottom: 0;
  width: auto;
  max-width: 35%; /* Prevent overlapping too much on smaller screens */
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  pointer-events: none; /* Let users click cards underneath if it overlaps */
}
.fhir-trainee-img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}

/* ════════════════════════════════════════
   Tablet (≤ 991px)
   ════════════════════════════════════════ */
@media (max-width: 991px) {
  .fhir-section {
    padding: 56px 40px 64px;
  }
  .fhir-inner {
    flex-direction: column;
    gap: 48px;
  }
  .fhir-left {
    width: 100%;
    max-width: 100%;
    z-index: 1; /* ensure cards stay above image if they overlap */
  }
  .fhir-right {
    display: none; /* 隱藏右側 trainee.webp 圖片 */
  }
}

/* ════════════════════════════════════════
   Mobile (≤ 768px)
   ════════════════════════════════════════ */
@media (max-width: 768px) {
  .fhir-section {
    padding: 48px 24px 56px;
    min-height: unset;
  }
  .fhir-h2 {
    font-size: 24px;
  }
  .fhir-title-icon {
    width: 36px;
    height: 36px;
  }
  .fhir-cards-container {
    flex-direction: column;
    gap: 16px;
  }
  .fhir-card {
    width: 100%;
    padding: 20px 20px 16px;
    border-radius: 14px;
    min-height: unset;
    gap: 12px;
  }
}

/* ════════════════════════════════════════
   Small mobile (≤ 400px)
   ════════════════════════════════════════ */
@media (max-width: 400px) {
  .fhir-section {
    padding: 40px 20px 48px;
  }
  .fhir-card {
    padding: 18px 16px 14px;
  }
}
</style>
